import React, { useState, useEffect } from 'react';
import CardCountMetric from '../CardCountMetric';
import api from '../../services/api';
import downloadFile from '../../utils/downloadFile';
import { notifyApiError } from '../../services/apiError';
import { store } from 'react-notifications-component';
import IconXlsx from '../../assets/icons/icon-baixar-xlsx.png';


import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const TotalAreaTratada = ({ dtInicial, dtFinal, ...props }) => {
    const [qtdArea, setQtdArea] = useState(null);
    const [trendPercent, setTrendPercent] = useState(null);
    const [loadingPdf, setShowLoadingPdf] = useState(false);

    const searchInitialData = async () => {
        setQtdArea(null);

        try {
            const response = await api.get('/relatorios/area-total', {
                params: { dtInicial, dtFinal },
            })
            setQtdArea(response.data.data.qtdArea);
            setTrendPercent(response.data.data.percentage ?? null);
        } catch (error) {
            notifyApiError(error, 'Falha ao carregar total de área tratada.');
        }
    }

    const gerarPDF = async () => {
        if (loadingPdf) return;

        try {
            setShowLoadingPdf(true);
            window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

            const response = await api.get(`/relatorios/area/pdf`, { params: { dtInicial, dtFinal } })

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-area.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true
                }
            });

        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setShowLoadingPdf(false);
            window.onbeforeunload = null;
        }
    }

    useEffect(() => {
        searchInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dtInicial, dtFinal])

    return (
        <CardCountMetric
            title="Total de área tratada"
            value={qtdArea !== null ? `${qtdArea} Ha` : null}
            loading={qtdArea === null || loadingPdf}
            trendPercent={trendPercent}
            trendLabel="vs. período anterior"
            isNew={trendPercent === null && qtdArea > 0}
            stackTrend
            actions={
                <a
                    onClick={() => gerarPDF()}
                    aria-disabled={loadingPdf}
                    style={{ cursor: loadingPdf ? 'not-allowed' : 'pointer', opacity: loadingPdf ? 0.4 : 1 }}
                >
                    <img width={18} src={IconXlsx} alt="Baixar XLSX" />
                </a>
            }
        />
    )
}

export default TotalAreaTratada;
